<template>
    <v-container>
        <v-layout>
            <v-flex md12>
                <v-card>
                    <v-card-title primary-title>
                        <div>
                            <h3 class="display-1 primary--text">Evaluaciones Realizadas</h3>
                        </div>
                    </v-card-title>
                    <v-card-text>
                        <v-form ref="form" v-model="valid" lazy-validation>
                            <v-layout row wrap>
                                <v-flex xs12 md4>
                                    <v-select
                                            v-model="periodoSeleccionado"
                                            :items="periodos"
                                            item-text="nombre"
                                            item-value="periodo"
                                            label="Periodo"
                                            :rules="[v => !!v || 'Selecciona un periodo']"
                                    ></v-select>
                                </v-flex>
                                <v-flex xs12 md4>
                                    <v-btn color="info" @click.native="generarImpresion" v-show="$mq !== 'sm'" :disabled="!valid">Imprimir</v-btn>
                                    <v-btn color="info" @click.native="descargarDocumento" v-show="$mq === 'sm'" :disabled="!valid">Descargar</v-btn>
                                </v-flex>
                            </v-layout>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
        <v-dialog v-model="generandoPdf" max-width="250px" persistent>
            <v-card>
                <v-card-title>
                    <v-progress-circular :size="50" indeterminate color="primary"></v-progress-circular>
                    <v-spacer></v-spacer>
                    <span style="width: 150px">{{generandoPdfMensaje}}</span>
                </v-card-title>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
  import axios from 'axios'
  import fileSaver from 'file-saver'
  import printJS from 'print-js'

  export default {
    name: 'EvaluacionesRealizadas',
    data: () => ({
      valid: false,
      periodos: [],
      cargandoDatos: false,
      generandoPdf: false,
      generandoPdfMensaje: '',
      periodoSeleccionado: null,
      showErrorMessage: false
    }),
    mounted () {
      this.getEncuestasRealizadas()
    },
    methods: {
      getEncuestasRealizadas () {
        this.cargandoDatos = true
        axios.get('alumno/evaluacion-docente/encuestas-realizadas')
          .then(resp => {
            this.cargandoDatos = false
            this.periodos = resp.data
          })
      },
      generarImpresion () {
        if (this.$refs.form.validate()) {
          this.generandoPdf = true
          this.generandoPdfMensaje = 'Se está generando el documento para impresión'
          axios.post('alumno/evaluacion-docente/imprimir-acuse', {periodo: this.periodoSeleccionado}, {responseType: 'arraybuffer'})
            .then(response => {
              this.generandoPdf = false
              this.generandoPdfMensaje = ''
              const blob = new Blob([response.data], {type: response.headers['content-type']})
              const fileURL = URL.createObjectURL(blob)
              printJS(fileURL)
            })
        }
      },
      descargarDocumento () {
        if (this.$refs.form.validate()) {
          this.generandoPdf = true
          this.generandoPdfMensaje = 'Se está generando el documento para descargar'
          axios.post('alumno/evaluacion-docente/imprimir-acuse', {periodo: this.periodoSeleccionado}, {responseType: 'arraybuffer'})
            .then(response => {
              this.generandoPdf = false
              this.generandoPdfMensaje = ''
              const blob = new Blob([response.data], {type: response.headers['content-type']})
              fileSaver.saveAs(blob, 'acuse-de-registro.pdf')
            })
        }
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/evaluacion-docente/EvaluacionesRealizadasPage.vue